import React from 'react';
import { string, array, bool } from 'prop-types';
import styles from './Branch.scss';
import TextPlaceholder from '../TextPlaceholder';
import { DeliveryIcon, LocationIcon } from './icons';
import classNames from 'classnames';

export default function Branch(props) {
  const deliveriesString = props.deliveryTypes.join(', ');

  return (
    <div className={styles.wrapper}>
      <TextPlaceholder
        size="medium"
        weight="normal"
        tagName="div"
        className={classNames([styles.ellipsis, props.isLoading && styles.titleLoading])}
        isLoading={props.isLoading}
      >
        {props.title}
      </TextPlaceholder>
      <TextPlaceholder
        size="tiny"
        weight="normal"
        secondary
        tagName="div"
        className={classNames([styles.ellipsis, props.isLoading && styles.addressLoading])}
        isLoading={props.isLoading}
      >
        {props.address}
      </TextPlaceholder>
      <div className={styles.metadata}>
        {!props.isLoading && <LocationIcon className={styles.icon} />}
        <TextPlaceholder
          size="tiny"
          weight="normal"
          secondary
          data-hook="branch-distance"
          className={classNames([props.isLoading && styles.metaDataLoading])}
          isLoading={props.isLoading}
        >
          {props.formattedDistance}
        </TextPlaceholder>
        {deliveriesString.length > 0 && (
          <React.Fragment>
            <span className={styles.gap} />
            {!props.isLoading && <DeliveryIcon className={styles.icon} />}
            <TextPlaceholder
              size="tiny"
              weight="normal"
              secondary
              data-hook="branch-deliveries"
              className={classNames([props.isLoading && styles.metaDataLoading])}
              isLoading={props.isLoading}
            >
              {deliveriesString}
            </TextPlaceholder>
          </React.Fragment>
        )}
      </div>
    </div>
  );
}

Branch.displayName = 'Branch';
Branch.propTypes = {
  title: string,
  address: string,
  formattedDistance: string,
  deliveryTypes: array,
  isLoading: bool,
};

Branch.defaultProps = {
  deliveryTypes: [],
};
